export const deleteProperty = (obj: { [k: string]: any }, key: string) => {
  const { [key]: _, ...newObj } = obj;
  return newObj;
};
